export default __webpack_public_path__ + "static/media/iconList.43914ce4.svg";